module.exports = __webpack_public_path__ + "static/media/greenroom.9d7f933b.png";